const ServicesItems = [
    {
        title: 'Survey Programming',
        path: '/surveyprogramming'
    },
    {
        title: 'Data Processing',
        path: '/dataprocessing'
    },
    {
        title: 'Panel Services',
        path: '/panel'
    },
    {
        title: 'Project Management',
        path: '/projectManagement'
    },
        {
        title: 'Consultancy Services',
        path: '/consultancy'
    },
   
   
]

export default ServicesItems